import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * Hook to detect token in URL and redirect to token login page - once per session
 */
export const useTokenRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const redirected = useRef(false);

  useEffect(() => {
    // Skip if we've already processed a token this session or if we're on the token login page
    if (
      redirected.current ||
      location.pathname === "/token-login" ||
      sessionStorage.getItem("token_redirect_done") === "true"
    ) {
      return;
    }

    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    // If token exists and we're not already at /token-login
    if (token && location.pathname !== "/token-login") {
      console.log("Token detected in URL, redirecting to dedicated handler...");
      redirected.current = true;
      sessionStorage.setItem("token_redirect_done", "true");

      // Extract all query parameters
      const allParams = new URLSearchParams(location.search);

      // Create the URL for token login page with token parameter
      navigate(`/token-login?${allParams.toString()}`, { replace: true });
    }
  }, [location, navigate]);
};

/**
 * Component to handle token redirect - runs once per session
 */
const TokenRedirect = () => {
  useTokenRedirect();
  return null;
};

export default TokenRedirect;
